import { AsyncMultiComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getPorts, type GetPortsParams } from '../../api/clients/port.api';
import { queries } from '../../api/queryKeys/queries';
import { formatPort } from '../../helpers/formatPort.helper';
import type { AsyncMultiSelectProps } from '../AsyncSelectProps';

interface PortMultiSelectProps extends AsyncMultiSelectProps {
    onChange: (portIds: string[]) => void;
    value: string[];
}

const loadPorts = async (params: GetPortsParams): Promise<ComboBoxOption[]> => {
    const response = await getPorts(params);

    return response.content.map((port) => ({
        value: port.id,
        label: formatPort({
            port,
        }) as ComboBoxOption['label'],
    }));
};

export function PortMultiSelect({ value, onChange, ...rest }: PortMultiSelectProps) {
    return (
        <AsyncMultiComboBox
            {...rest}
            value={value}
            onChange={onChange}
            optionsQueryKey={(search) => queries.ports.comboBoxOptions({ searchQuery: search }).queryKey}
            optionsQueryFn={(search) => loadPorts({ searchQuery: search })}
            selectedOptionsQueryKey={(values) => queries.ports.comboBoxOptions({ ids: values }).queryKey}
            selectedOptionsQueryFn={(values) => loadPorts({ ids: values })}
        />
    );
}
